import { Link } from "react-router-dom";
import { formatDuration, formatViews, type Movie } from "@/utils/movie";

type MovieCardCompactProps = {
  movie: Movie;
};

export default function MovieCardCompact({ movie }: MovieCardCompactProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group flex items-center gap-4 py-4 transition-colors hover:bg-background-50"
    >
      <div className="h-24 w-16 shrink-0 overflow-hidden rounded-md bg-secondary-200">
        <img src={movie.poster} alt={`${movie.title} 海报`} title={movie.title} className="h-full w-full object-top" />
      </div>
      <div className="min-w-0 flex-1">
        <h3 className="font-heading text-sm font-semibold text-foreground-950 transition-colors group-hover:text-accent-600">
          {movie.title}
        </h3>
        <p className="mt-1 line-clamp-2 text-xs leading-relaxed text-foreground-600">{movie.synopsis}</p>
        <div className="mt-2 flex flex-wrap items-center gap-3 text-xs text-foreground-500">
          <span className="flex items-center gap-0.5">
            <i className="ri-star-fill text-accent-500"></i>
            {movie.rating.toFixed(1)}
          </span>
          <span>{movie.year}</span>
          <span>{formatDuration(movie.duration)}</span>
          <span className="flex items-center gap-0.5">
            <i className="ri-fire-line text-accent-500"></i>
            {formatViews(movie.views)}
          </span>
        </div>
      </div>
      <i className="ri-arrow-right-s-line hidden text-xl text-foreground-400 transition-colors group-hover:text-accent-500 sm:block"></i>
    </Link>
  );
}